import { render, staticRenderFns } from "./User-list.vue?vue&type=template&id=4aaa7075"
import script from "./User-list.vue?vue&type=script&lang=js"
export * from "./User-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports